import React from "react";

interface CardProps extends React.HTMLAttributes<HTMLElement>{
 
}

class Card extends React.Component<CardProps> {
  render() {
    return (
      <div
        {...this.props}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Card;